<template>
  <div class="container">
    <contact-bar></contact-bar>
    <navigation-bar></navigation-bar>
    <div class="block pb-6 pt-6">
      <h1
        class="has-text-centered has-text-primary"
        :class="width < 768 ? 'is-size-3' : 'is-size-1'"
        style="font-family: Calibri; font-weight: bold"
      >
        NOSOTROS Y NUESTRA HISTORIA
      </h1>
      <div class="columns is-centered is-mobile">
        <div
          class="column"
          :class="width < 768 ? 'is-four-fifths' : 'is-two-thirds'"
        >
          <p
            class="has-text-primary has-text-centered is-size-6 pt-4 pb-6"
            style="font-family: Calibri; font-weight: bold"
          >
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
            nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat
            volutpat.
          </p>
        </div>
      </div>
    </div>
  </div>
  <figure class="image">
    <img
      class="has-ratio"
      src="../assets/imagen_nosotros_alfapack.png"
      alt="imagen_nosotros_alfapack.png"
    />
  </figure>
  <div class="container pt-6 pb-6">
    <div class="columns is-centered is-mobile pb-6">
      <div
        class="column"
        :class="width < 768 ? 'is-four-fifths' : 'is-two-thirds'"
      >
        <h1
          class="has-text-centered has-text-primary"
          :class="width < 768 ? 'is-size-3' : 'is-size-1'"
          style="font-family: Calibri; font-weight: bold"
        >
          ESTAMOS PRESENTES EN MÉXICO, CENTROAMÉRICA, EL CARIBE
        </h1>
      </div>
    </div>
    <div class="block">
      <div class="columns is-mobile">
        <div class="column">
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            <svg-icon
              type="mdi"
              class="p-4"
              :path="mdiMapMarker"
              style="
                color: white;
                background-color: #38ac61;
                vertical-align: text-bottom;
                width: 110px;
                height: 110px;
                border-radius: 50%;
              "
            ></svg-icon>
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6 pt-4"
            style="font-family: Calibri; font-weight: bold"
          >
            ESTADO DE MÉXICO
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            contacto@alfapack.com.mx
          </p>
        </div>
        <div class="column">
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            <svg-icon
              type="mdi"
              class="p-4"
              :path="mdiMapMarker"
              style="
                color: white;
                background-color: #38ac61;
                vertical-align: text-bottom;
                width: 110px;
                height: 110px;
                border-radius: 50%;
              "
            ></svg-icon>
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6 pt-4"
            style="font-family: Calibri; font-weight: bold"
          >
            MÉRIDA
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            Miracañada #10, Cumbria, Cuautitlán Izcalli, C.P. 54740
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            T. +52 (55) 2870-5700 | W. +52 (55) 1335-0671
          </p>
          <p
            class="has-text-primary has-text-centered is-size-6"
            style="font-family: Calibri; font-weight: bold"
          >
            contacto@alfapack.com.mx
          </p>
        </div>
      </div>
    </div>
  </div>
  <section class="hero p-2" style="background-color: #f4f4f6">
    <div class="container">
      <div class="block pt-6">
        <h1
          class="has-text-centered has-text-primary"
          :class="width < 768 ? 'is-size-3' : 'is-size-1'"
          style="font-family: Calibri; font-weight: bold"
        >
          INDUSTRIAS
        </h1>
        <p class="has-text-primary has-text-centered has-text-weight-bold">
          Esto manejamos <span class="has-text-yellow">contáctanos.</span>
        </p>
      </div>
      <div class="block pt-6">
        <div class="columns is-variable is-4">
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-4"
              style="font-family: Calibri; font-weight: bold"
            >
              <svg-icon
                class="p-4"
                type="mdi"
                :path="mdiFoodApple"
                style="
                  color: white;
                  background-color: #38ac61;
                  vertical-align: text-bottom;
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  padding: 0.75rem;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Alimentos
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-0"
              style="font-family: Calibri; font-weight: bold"
            >
              <img
                src="../assets/Bebidas.svg"
                alt="Bebidas.svg"
                width="125"
                height="125"
              />
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Bebidas
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-4"
              style="font-family: Calibri; font-weight: bold"
            >
              <svg-icon
                class="p-4"
                type="mdi"
                :path="mdiPill"
                style="
                  color: white;
                  background-color: #38ac61;
                  vertical-align: text-bottom;
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  padding: 0.75rem;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Pharma
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-4"
              style="font-family: Calibri; font-weight: bold"
            >
              <svg-icon
                class="p-4"
                type="mdi"
                :path="mdiCar"
                style="
                  color: white;
                  background-color: #38ac61;
                  vertical-align: text-bottom;
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  padding: 0.75rem;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Automotriz
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
        </div>
      </div>
      <div class="block pb-6" :class="width < 768 ? '' : 'pt-6'">
        <div class="columns is-variable is-4">
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-4"
              style="font-family: Calibri; font-weight: bold"
            >
              <svg-icon
                class="p-4"
                type="mdi"
                :path="mdiPackageVariantClosed"
                style="
                  color: white;
                  background-color: #38ac61;
                  vertical-align: text-bottom;
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  padding: 0.75rem;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Empaque y Embalaje
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-4"
              style="font-family: Calibri; font-weight: bold"
            >
              <svg-icon
                class="p-4"
                type="mdi"
                :path="mdiLeaf"
                style="
                  color: white;
                  background-color: #38ac61;
                  vertical-align: text-bottom;
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  padding: 0.75rem;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Nutracéutica
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-4"
              style="font-family: Calibri; font-weight: bold"
            >
              <svg-icon
                class="p-4"
                type="mdi"
                :path="mdiCheese"
                style="
                  color: white;
                  background-color: #38ac61;
                  vertical-align: text-bottom;
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  padding: 0.75rem;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lacteos
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
          <div class="column">
            <p
              class="has-text-primary has-text-centered is-size-6 pb-4"
              style="font-family: Calibri; font-weight: bold"
            >
              <svg-icon
                class="p-4"
                type="mdi"
                :path="mdiFlaskRoundBottom"
                style="
                  color: white;
                  background-color: #38ac61;
                  vertical-align: text-bottom;
                  width: 110px;
                  height: 110px;
                  border-radius: 50%;
                  padding: 0.75rem;
                "
              ></svg-icon>
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Química
            </p>
            <p
              class="has-text-centered has-text-primary has-text-weight-bold"
              style="font-family: Calibri"
            >
              Lorem ipsum dolor sit amet, consectetuer adipiscing elit
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <difference-component></difference-component>
  <contact-media></contact-media>
  <footer-component></footer-component>
</template>

<script setup lang="ts">
import ContactBar from "@/components/ContactBar.vue";
import NavigationBar from "@/components/NavigationBar.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import DifferenceComponent from "@/components/DifferenceComponent.vue";
import ContactMedia from "@/components/ContactMedia.vue";
import { useWindowSize } from "vue-window-size";
import SvgIcon from "@jamescoyle/vue-icon";
import {
  mdiMapMarker,
  mdiFoodApple,
  mdiPill,
  mdiCar,
  mdiPackageVariantClosed,
  mdiFlaskRoundBottom,
  mdiLeaf,
  mdiCheese,
} from "@mdi/js";

const { width } = useWindowSize();
</script>
